import stdreqLabels from 'assets/labels/stdapplinf'
// import moment from 'moment'
// import faker from 'faker'

export const mocker = {
  labels () {
    return {
      labels: stdreqLabels
    }
  },
  index () {
    let tapplinfData = {
      numappl: '',
      desc_numappl: ''
    }

    return {
      tapplinf: tapplinfData
    }
  },
  tappoinf () {
    let mockRows = []
    const mockTotal = 1
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        numapseq: 'numapseq',
        codappty: 'codappty',
        dteappoi: 'dteappoi',
        qtyfscore: 'qtyfscore',
        numgrd: 'numgrd'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/stdapplinf/mocker.js